import { Avatar } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { getUserDisplayNames, getUserInitials } from './formatters';
const Container = styled.div `
  display: flex;
  align-items: center;
`;
const StyledAvatar = styled(Avatar) `
  flex-shrink: 0;
  font-weight: bold;

  ${({ type }) => type === 'primary'
    ? `
    color: ${theme.colors.litePurple};
    background-color: ${theme.colors.purple};
    `
    : `
    color: ${theme.colors.purple};
    background-color: ${theme.colors.litePurple};
  `}

  ${(props) => props.userdisabled === 'true' &&
    `
    color: #fff;
    background-color: ${theme.greys.disabled};
  `}
`;
export const DisplayName = styled.span `
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 12px;
`;
export const UserAvatar = (props) => {
    return (React.createElement(Container, null,
        React.createElement(StyledAvatar, { userdisabled: props.userInfo.enabled ? 'false' : 'true', type: props.type, src: props.userInfo.profileImage, alt: props.alt }, getUserInitials(props.userInfo)),
        !props.hideDisplayName && (React.createElement(DisplayName, null,
            getUserDisplayNames(props.userInfo).join(' '),
            ' ',
            props.userInfo.enabled ? null : props.userDisabledText))));
};
